"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _showdown = _interopRequireDefault(require("showdown"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _rehypeRaw = _interopRequireDefault(require("rehype-raw"));

var _remarkBreaks = _interopRequireDefault(require("remark-breaks"));

var _remarkGfm = _interopRequireDefault(require("remark-gfm"));

var _table = require("@jsluna/table");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MarkdownReader = function MarkdownReader(_ref) {
  var input = _ref.input;

  var formatInput = function formatInput(input) {
    if (input === undefined) {
      return '';
    }

    var converter = new _showdown.default.Converter({
      emoji: true,
      strikethrough: true,
      tasklists: true,
      ghCodeBlocks: true,
      simplifiedAutoLink: true
    });
    return converter.makeHtml(input);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Retail__MarkdownReader"
  }, /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, {
    components: {
      // eslint-disable-next-line react/display-name
      link: function link(x) {
        return /*#__PURE__*/_react.default.createElement("a", {
          className: "ln-u-text-decoration-underline link",
          target: "_blank",
          rel: "noopener noreferrer",
          href: x.href
        }, x.children);
      },
      // eslint-disable-next-line react/display-name
      table: function table(x) {
        function isObject(val) {
          if (val === null) {
            return false;
          }

          return typeof val === 'function' || typeof val === 'object';
        }

        var resolveCellValue = function resolveCellValue(val) {
          if (isObject(val)) {
            return _react.default.Children.toArray(val.props.children)[0];
          }

          return val && val.length > 0 ? val : '';
        };

        var header = x.children.filter(function (y) {
          return y.type === 'thead';
        }).map(function (h) {
          return _react.default.Children.toArray(h.props.children);
        })[0].filter(function (z) {
          return z.type === 'tr';
        })[0];

        var headerCells = _react.default.Children.toArray(header.props.children).map(function (h) {
          return _react.default.Children.toArray(h.props.children);
        }).map(function (res) {
          return res[0];
        }).map(function (cell) {
          return resolveCellValue(cell);
        });

        var body = x.children.filter(function (y) {
          return y.type === 'tbody';
        });
        var bodyRows = body.map(function (b) {
          return _react.default.Children.toArray(b.props.children);
        })[0].filter(function (r) {
          return r.type === 'tr';
        }).map(function (b) {
          return _react.default.Children.toArray(b.props.children);
        });
        var bodyRowValues = bodyRows.map(function (b) {
          return b.map(function (br) {
            return _react.default.Children.toArray(br.props.children);
          }).map(function (res) {
            return res[0];
          });
        });
        var data = Array.from({
          length: bodyRowValues.length
        }, Object);
        bodyRowValues.map(function (row, r) {
          return data[r]['rowId'] = "rowData-" + r, row.map(function (cell, j) {
            return data[r][headerCells[j]] = resolveCellValue(cell);
          });
        });
        return /*#__PURE__*/_react.default.createElement(_table.Table, {
          rowKey: "rowId",
          responsive: true,
          data: data,
          columns: headerCells.map(function (header) {
            return {
              name: header,
              accessor: function accessor(rowData) {
                return {
                  value: rowData[header]
                };
              }
            };
          })
        });
      }
    },
    rehypePlugins: [_rehypeRaw.default],
    remarkPlugins: [_remarkBreaks.default, _remarkGfm.default]
  }, formatInput(input)));
};

MarkdownReader.propTypes = {
  input: _propTypes.default.string.isRequired
};
var _default = MarkdownReader;
exports.default = _default;